/* eslint-disable */
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import moment from 'moment';
import Modal from 'react-modal';
import { ROOT_URL_V2 } from '../../../config';
import BookingDetailsFeedback from './booking-details-feedback/BookingDetailsFeedback';
import './bookingsFeedbackModal.scss';
import { flattenBookingsToJobs } from '../../../api/DataHandlers';

class BookingRequireFeedback extends Component {
    constructor(props) {
        super(props);

        this.state = {
            jobs: [],
            totalReviewsRequired: 0,
            activeJobIndex: 0,
            isPostInProgress: false,
            hasNextUrl: false,
        };
    }

    componentDidMount() {
        this.fetchJobs();
    }

    fetchJobs() {
        this.setState({
            isPostInProgress: true,
        });
        axios({
            method: 'get',
            url: `${ROOT_URL_V2}jobs/?feedbackneeded=1`,
        })
            .then(response => {
                const jobs = flattenBookingsToJobs(response.data).content;
                this.setState({
                    jobs,
                    totalReviewsRequired:
                        response.data.meta.bookings_count || jobs.length,
                    activeJobIndex: 0,
                    isPostInProgress: false,
                    hasNextUrl: !!response.data.meta.next,
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    onFeedbackPostStart() {
        this.setState({
            isPostInProgress: true,
        });
    }

    onFeedbackPostEnd() {
        this.setState({
            isPostInProgress: false,
        });
    }

    onFeedbackPostSuccess() {
        const { jobs, activeJobIndex, totalReviewsRequired } = this.state;
        this.setState({
            jobs: jobs.filter((job, index) => index !== activeJobIndex),
            activeJobIndex:
                activeJobIndex < jobs.length - 1 ? activeJobIndex : 0,
            totalReviewsRequired: totalReviewsRequired - 1,
        });
    }

    onPrevClick() {
        const { activeJobIndex } = this.state;
        if (activeJobIndex > 0) {
            this.setState({
                activeJobIndex: activeJobIndex - 1,
            });
        }
    }

    onNextClick() {
        const { jobs, activeJobIndex, hasNextUrl } = this.state;
        if (activeJobIndex < jobs.length - 1) {
            this.setState({
                activeJobIndex: activeJobIndex + 1,
            });
        } else if (hasNextUrl) {
            this.fetchJobs();
        }
    }

    renderFreelancerDetails() {
        const { jobs, activeJobIndex } = this.state;
        const job = jobs[activeJobIndex];
        const freelancerData = jobs[activeJobIndex].booking.freelancer_detail;
        const photoThumbnail = freelancerData.photo_thumbnail_large
            ? freelancerData.photo_thumbnail_large
            : '/static/images/default_profile.png';
        return (
            <div className="feedback-modal__worker">
                <div className="feedback-modal__avatar">
                    <img src={photoThumbnail} />
                </div>
                <div className="feedback-modal__name">
                    {freelancerData.full_name}
                </div>
                <div className="feedback-modal__details">
                    <div>
                        worked for you {moment(job.start_datetime).fromNow()}
                    </div>
                    <div>
                        {moment(job.start_datetime).format(
                            'dddd DD MMM YYYY, HH:mm',
                        )}{' '}
                        &mdash; {moment(job.end_datetime).format('HH:mm')}
                    </div>
                </div>
            </div>
        );
    }

    renderFooter() {
        const { totalReviewsRequired } = this.state;
        const href = '/operations/bookings/?bookings_status=FR&getall=1';
        const otherReviewsLeft = totalReviewsRequired - 1;
        return otherReviewsLeft ? (
            <div className="feedback-modal__footer">
                <span>
                    {otherReviewsLeft} more reviews to leave.{' '}
                    <Link to={href}>View all</Link>
                </span>
            </div>
        ) : null;
    }

    render() {
        const {
            jobs,
            totalReviewsRequired,
            activeJobIndex,
            hasNextUrl,
            isPostInProgress,
        } = this.state;
        const job = jobs[activeJobIndex];
        if (totalReviewsRequired && job) {
            const freelancerData = job.booking.freelancer_detail;
            const hasPrevBookings = !isPostInProgress && activeJobIndex !== 0;
            const hasNextBookings =
                !isPostInProgress &&
                (activeJobIndex < jobs.length - 1 || hasNextUrl);
            return (
                <div>
                    <Modal
                        className="feedback-modal"
                        isOpen={true}
                        contentLabel="Bookings Feedback Modal"
                    >
                        <div className="feedback-modal__left-control">
                            {hasPrevBookings ? (
                                <button onClick={this.onPrevClick.bind(this)}>
                                    <i className="icon icon-arrow-left-12" />
                                </button>
                            ) : null}
                        </div>
                        <div className="feedback-modal__main">
                            <h2 className="feedback-modal__title">
                                How would you rate {freelancerData.first_name}?
                            </h2>
                            {this.renderFreelancerDetails()}
                            <div className="feedback-modal__feedback">
                                <BookingDetailsFeedback
                                    job={jobs[activeJobIndex]}
                                    onFeedbackPostStart={this.onFeedbackPostStart.bind(
                                        this,
                                    )}
                                    onFeedbackPostEnd={this.onFeedbackPostEnd.bind(
                                        this,
                                    )}
                                    onFeedbackPostSuccess={this.onFeedbackPostSuccess.bind(
                                        this,
                                    )}
                                />
                            </div>
                            {this.renderFooter()}
                        </div>
                        <div className="feedback-modal__right-control">
                            {hasNextBookings ? (
                                <button onClick={this.onNextClick.bind(this)}>
                                    <i className="icon icon-arrow-right-12" />
                                </button>
                            ) : null}
                        </div>
                    </Modal>
                </div>
            );
        }

        return null;
    }
}

export default BookingRequireFeedback;
